import * as React from "react"

const _NoseLong = ({ isEditor }: { isEditor: boolean }) => {
  return (
    <svg
      style={{
        width: !isEditor ? "10%" : "60%",
        height: !isEditor ? "10%" : "60%",
        position: "absolute",
        top: !isEditor ? "15%" : "20%",
        left: !isEditor ? "46%" : "30%"
      }}
      width="32"
      height="40"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 3C16.5 17 23.5 28 23.5 28C23.5 28 20 34 10 32"
        stroke="#171921"
        strokeWidth="4"
      />
    </svg>
  )
}

export const NoseLong = React.memo(_NoseLong)
